import * as yup from 'yup';

// const phoneRegExp = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/

export default yup.object().shape({
  email: yup.string().email().required('Geef je e-mailadres op!'),
  // phone: yup.string().matches(phoneRegExp, 'Phone number is not valid').required()
});